class QuickView {
  constructor() {
    this.selectors = {
      quickViewButton: '[data-quick-view-button]',
      quickViewModal: '[data-quick-view-modal]',
      modalContainer: '[data-modal-container]',
      modalClose: '[data-modal-close]',
      modalOverlay: '.quick-view-modal__overlay',
      quickViewContent: '[data-quick-view-content]',
      loadingOverlay: '.loading-overlay',
    };
    
    this.classes = {
      active: 'active',
      loading: 'loading',
      open: 'open',
      activeModal: 'modal--open',
      hidden: 'hide',
      thumbnailActive: 'active-thumbnail',
      imgLoaded: 'img-loaded',
      liftUpDisable: 'lift-up-disabled',
    };
    
    this.modal = document.querySelector(this.selectors.quickViewModal);
    this.init();
  }
  
  init() {
    this.initModal();
    this.initEventListeners();
  }
  
  initModal() {
    if (!this.modal) {
      // Create modal if it doesn't exist
      const modalHTML = `
        <div class="quick-view-modal" data-quick-view-modal>
          <div class="quick-view-modal__overlay" data-modal-close></div>
          <div class="quick-view-modal__container">
            <button class="quick-view-modal__close" data-modal-close>
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div class="quick-view-modal__content" data-modal-container></div>
          </div>
        </div>
      `;
      
      const modalElement = document.createElement('div');
      modalElement.innerHTML = modalHTML;
      document.body.appendChild(modalElement.firstElementChild);
      this.modal = document.querySelector(this.selectors.quickViewModal);
      
      // Add styles if not already present
      if (!document.getElementById('quick-view-styles')) {
        const styles = document.createElement('style');
        styles.id = 'quick-view-styles';
        styles.textContent = `
          .quick-view-modal {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 999;
            opacity: 0;
            transition: opacity 0.3s ease;
          }
          
          .quick-view-modal.open {
            display: flex;
            justify-content: center;
            align-items: center;
            opacity: 1;
          }
          
          .quick-view-modal__overlay {
            display: block !important;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
            cursor: pointer;
          }
          
          .quick-view-modal__container {
            position: relative;
            width: 95%;
            max-width: 1000px;
            max-height: 90vh;
            margin: 0 auto;
            background-color: #fff;
            overflow-y: auto;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
            z-index: 1;
            transform: translateY(20px);
            transition: transform 0.3s ease;
            border-radius: 8px;
          }
          
          .quick-view-modal.open .quick-view-modal__container {
            transform: translateY(0);
          }
          
          .quick-view-modal__close {
            position: absolute;
            top: 15px;
            right: 15px;
            background: transparent;
            border: none;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 10;
            transition: background-color 0.2s ease;
          }
          
          .quick-view-modal__close:hover {
            background-color: #f5f5f5;
          }
          
          .quick-view-modal__close svg {
            width: 40px;
            height: 40px;
          }
          
          .quick-view-modal__content {
            position: relative;
          }
          
          .quick-view-modal__content.loading::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(255, 255, 255, 0.8);
            z-index: 1;
          }
          
          .quick-view-modal__content.loading::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 40px;
            height: 40px;
            margin: -20px 0 0 -20px;
            border-radius: 50%;
            border: 3px solid rgba(0, 0, 0, 0.1);
            border-top-color: #000;
            animation: spin 0.6s linear infinite;
            z-index: 2;
          }
          
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
          
          @media screen and (max-width: 749px) {
            .quick-view-modal__container {
              max-height: 100vh;
              width: 100%;
              border-radius: 0;
            }
          }
        `;
        document.head.appendChild(styles);
      }
    }
  }
  
  initEventListeners() {
    document.addEventListener('click', this.handleDocumentClick.bind(this));
    
    // Close modal when pressing ESC
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isModalOpen()) {
        this.closeModal();
      }
    });
    

    if (this.modal) {
      this.modal.addEventListener('click', (event) => {
  
        if (event.target.closest(this.selectors.modalClose) || event.target === this.modal.querySelector(this.selectors.modalOverlay)) {
          this.closeModal();
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  }
  
  handleDocumentClick(event) {
    const quickViewButton = event.target.closest(this.selectors.quickViewButton);
    
    if (quickViewButton) {
      event.preventDefault();
      const productUrl = quickViewButton.getAttribute('data-product-url');
      
      if (productUrl) {
        this.openQuickView(productUrl);
      }
    }
  }
  
  openQuickView(productUrl) {
    this.openModal();
    this.loadProductContent(productUrl);
  }
  
  loadProductContent(productUrl) {
    const modalContainer = this.modal.querySelector(this.selectors.modalContainer);
    const loadingOverlay = this.modal.querySelector(this.selectors.loadingOverlay);
    modalContainer.classList.add(this.classes.loading);
    
    if (loadingOverlay) loadingOverlay.classList.remove(this.classes.hidden);
    
    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('view', 'quick-view-modal');
    
    fetch(url.toString())
      .then(response => response.text())
      .then(html => {
        modalContainer.innerHTML = html;
        modalContainer.classList.remove(this.classes.loading);
        
        this.initQuickViewScripts();
        
        if (loadingOverlay) loadingOverlay.classList.add(this.classes.hidden);
      })
      .catch(error => {
        console.error('Error loading quick view content:', error);
        modalContainer.innerHTML = '<p>Error loading product information. Please try again.</p>';
        modalContainer.classList.remove(this.classes.loading);
        
        if (loadingOverlay) loadingOverlay.classList.add(this.classes.hidden);
      });
  }
  
  initQuickViewScripts() {

    if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }
    
 
    const scripts = this.modal.querySelectorAll('script');
    scripts.forEach(script => {
      const newScript = document.createElement('script');
      Array.from(script.attributes).forEach(attr => {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.appendChild(document.createTextNode(script.innerHTML));
      script.parentNode.replaceChild(newScript, script);
    });
    

    this.initThumbnailButtons();
    this.initNavArrows();
    

    this.initThumbnailDragScroll();
  }
  
  initThumbnailButtons() {
    const thumbnailButtons = this.modal.querySelectorAll('.thumbnail-button');
    const featuredImage = this.modal.querySelector('.quick-view-featured-image');
    
    if (!thumbnailButtons.length || !featuredImage) return;
    
    thumbnailButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        const imageUrl = button.getAttribute('data-image');
        if (imageUrl && featuredImage) {
          featuredImage.src = imageUrl;
          

          thumbnailButtons.forEach(btn => {
            btn.parentElement.classList.remove(this.classes.thumbnailActive);
          });
          

          button.parentElement.classList.add(this.classes.thumbnailActive);
        }
      });
      

      if (thumbnailButtons[0] && !document.querySelector(`.${this.classes.thumbnailActive}`)) {
        thumbnailButtons[0].parentElement.classList.add(this.classes.thumbnailActive);
      }
    });
  }
  
  initNavArrows() {
    const prevArrow = this.modal.querySelector('.quick-view-prev-arrow');
    const nextArrow = this.modal.querySelector('.quick-view-next-arrow');
    const thumbnailItems = this.modal.querySelectorAll('.thumbnail-item');
    const featuredImage = this.modal.querySelector('.quick-view-featured-image');
    
    if (!prevArrow || !nextArrow || !thumbnailItems.length || !featuredImage) return;
    

    if (thumbnailItems.length <= 1) {
      prevArrow.style.display = 'none';
      nextArrow.style.display = 'none';
      return;
    }
    
    prevArrow.addEventListener('click', () => {

      let activeIndex = -1;
      thumbnailItems.forEach((item, index) => {
        if (item.classList.contains(this.classes.thumbnailActive)) {
          activeIndex = index;
        }
      });
      
      if (activeIndex > 0) {

        const prevIndex = activeIndex - 1;
        const prevThumbnail = thumbnailItems[prevIndex].querySelector('.thumbnail-button');
        const imageUrl = prevThumbnail.getAttribute('data-image');
        
        if (imageUrl) {
          featuredImage.src = imageUrl;
          

          thumbnailItems.forEach(item => item.classList.remove(this.classes.thumbnailActive));
          thumbnailItems[prevIndex].classList.add(this.classes.thumbnailActive);
        }
      }
    });
    
    nextArrow.addEventListener('click', () => {

      let activeIndex = -1;
      thumbnailItems.forEach((item, index) => {
        if (item.classList.contains(this.classes.thumbnailActive)) {
          activeIndex = index;
        }
      });
      
      if (activeIndex < thumbnailItems.length - 1) {

        const nextIndex = activeIndex + 1;
        const nextThumbnail = thumbnailItems[nextIndex].querySelector('.thumbnail-button');
        const imageUrl = nextThumbnail.getAttribute('data-image');
        
        if (imageUrl) {
          featuredImage.src = imageUrl;
          

          thumbnailItems.forEach(item => item.classList.remove(this.classes.thumbnailActive));
          thumbnailItems[nextIndex].classList.add(this.classes.thumbnailActive);
        }
      }
    });
  }
  
  initThumbnailDragScroll() {
    const thumbnailsContainer = this.modal.querySelector('.quick-view-thumbs');
    const thumbnailsList = this.modal.querySelector('.thumbnails-list');
    
    if (!thumbnailsContainer || !thumbnailsList) return;
    
    let isDown = false;
    let startX;
    let scrollLeft;
    

    thumbnailsList.classList.add('draggable');
    

    thumbnailsList.addEventListener('mousedown', (e) => {
      isDown = true;
      thumbnailsList.classList.add('active-drag');
      startX = e.pageX - thumbnailsList.offsetLeft;
      scrollLeft = thumbnailsList.scrollLeft;
      e.preventDefault();
    });
    
    thumbnailsList.addEventListener('mouseleave', () => {
      isDown = false;
      thumbnailsList.classList.remove('active-drag');
    });
    
    thumbnailsList.addEventListener('mouseup', () => {
      isDown = false;
      thumbnailsList.classList.remove('active-drag');
    });
    
    thumbnailsList.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - thumbnailsList.offsetLeft;
      const walk = (x - startX) * 2; 
      thumbnailsList.scrollLeft = scrollLeft - walk;
    });
    
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      .thumbnails-list.draggable {
        cursor: grab;
        user-select: none;
      }
      
      .thumbnails-list.active-drag {
        cursor: grabbing;
      }
      
      .quick-view-thumbs {
        overflow: hidden;
      }
      
      .thumbnails-list {
        overflow-x: auto;
        scrollbar-width: none;  /* Firefox */
        -ms-overflow-style: none;  /* IE/Edge */
        scroll-behavior: smooth;
      }
      
      .thumbnails-list::-webkit-scrollbar {
        display: none;  /* Chrome, Safari, Opera */
      }
    `;
    document.head.appendChild(styleElement);
  }
  
  openModal() {
    if (this.modal) {

      this.modal.classList.add(this.classes.open);
      
      document.body.style.overflow = 'hidden';
      
      this.announceModal('Modal opened');
    }
  }
  
  closeModal() {
    if (this.modal) {
      this.modal.classList.remove(this.classes.open);
      
      document.body.style.overflow = '';
      
      this.announceModal('Modal closed');
      
      setTimeout(() => {
        const modalContainer = this.modal.querySelector(this.selectors.modalContainer);
        if (modalContainer) {
          modalContainer.innerHTML = '';
        }
      }, 300);
    }
  }
  
  announceModal(message) {
    let announcer = document.getElementById('quick-view-announcer');
    if (!announcer) {
      announcer = document.createElement('div');
      announcer.id = 'quick-view-announcer';
      announcer.setAttribute('aria-live', 'polite');
      announcer.setAttribute('class', 'visually-hidden');
      document.body.appendChild(announcer);
    }
    announcer.textContent = message;
  }
  
  isModalOpen() {
    return this.modal && this.modal.classList.contains(this.classes.open);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new QuickView();
}); 


  document.addEventListener('DOMContentLoaded', function() {

    const thumbnailButtons = document.querySelectorAll('.thumbnail-button');
    const featuredImage = document.getElementById('QuickViewFeatured-{{ product.id }}');
    
    if (thumbnailButtons.length > 0 && featuredImage) {
    
      thumbnailButtons[0].classList.add('active');
      
      thumbnailButtons.forEach(button => {
        button.addEventListener('click', function() {

          featuredImage.src = this.dataset.image;
          
          thumbnailButtons.forEach(btn => btn.classList.remove('active'));
          this.classList.add('active');
        });
      });
    }
  });

